export const environment = {
  config: {
    version: '2.6',
    production: true,
    dev: false,
    demo: false,
    local: false,
    noPpImage: 'https://material.angular.io/assets/img/examples/shiba1.jpg',
    chartExportUrl: 'https://export.soprism.com',
    apiErrorCheck: true,
    api: {
      statsUrl: 'https://stats.soprism.com',
      baseUrl: 'https://core.soprism.com/',
      storageUrl: 'https://assets-cdn01.soprism.com/core/',
      diBaseUrl: 'https://di-linkedin-backend.audiense.com/'
    },
    tracking: {
      enabled: true
    },
    segment: {
      apiKey: 'CZMrKZHIV4YEY6Kd7bQr1QhDRPmocR3L',
      cdnURL: 'https://evs.cdp6421.audiense.com',
      apiHost: 'api.cdp6421.audiense.com/v1'
    },
    pptx: {
      api: 'https://pptx.soprism.com'
    },
    posthog: {
      enabled: true,
      apiKey: 'phc_WfrZZqaqNwaD2UxCSGMzEWOsDKWF3dpMOVtnvHjRRSE',
      host: 'https://ff3478.audiense.com'
    },
    rollbar: {
      enabled: true
    },
    dataManager: {
      domain: 'control.soprism.com'
    },
    digitalIntelligence: {
      domain: 'https://digital-intelligence.audiense.com'
    },
    audiensePlatform: {
      apiUrl: 'https://platform-api.audiense.com',
      shellUrl: 'https://app.audiense.com'
    },
    interestCategories: {
      // Brussels wall-clock (CEST, +02:00) of the deploy — matches naive `created_at` stored by the API.
      newTagsCutoff: '2026-05-18T16:55:42.000+02:00'
    },
    allowCustomTokenUse: true,
    enableLogging: true,
    showLogMinPriority: 2,
    customFlexTypesAsRigid: false,
    enableDebugFeatures: false,
    enableLocalDevelopmentFeatures: false,
    showMapEditMenu: false,
    fbAppId: '724584387569638',
    fbVersion: 'v25.0',
    adminBypass: false
  },
  frontegg: {
    baseUrl: 'https://auth2.audiense.com',
    clientId: 'c86a66fd-0380-49dd-adc0-5bf4818bfddb',
    appId: '875ef48a-c4b4-428e-b25f-863a6bd619d2'
  }
};